import Vue from 'vue'
import HttpService from '@/services/http.service'

import store from '@/store'
import router from '@/router'

Vue.use(HttpService)

export default function role ({ next }) {
  Vue.prototype.$http.get('api/v2/auth/user')
    .then(response => {
      store.dispatch('setUser', response.data).catch()
      store.dispatch('setRole', response.data.role).catch()
      // eslint-disable-next-line handle-callback-err
      router.push({ name: `dashboard.${response.data.role}` }).catch(error => {})
    })
    .catch(() => {
      return next({
        name: 'main'
      })
    })
}
